import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar } from '../../Calendar';
import { useDatePicker } from '../DatePickerContext';
export const DatePickerCalendar = () => {
    const { colorScheme, internalValue, handleDateChange, initialFocusRef, size, isMobile, calendarProps: { isCalendarFixedHeight, ...restCalendarProps }, } = useDatePicker();
    const displayedSize = isMobile ? 'sm' : size;
    return (_jsx(Calendar, { size: displayedSize, colorScheme: colorScheme, value: internalValue ?? undefined, onChange: handleDateChange, ref: initialFocusRef, isCalendarFixedHeight: isMobile ? true : isCalendarFixedHeight, ...restCalendarProps }));
};
